import { Navigate } from 'react-router-dom';

interface RouteGuardProps {
	children: React.ReactNode;
}

export const RouteGuard: React.FC<RouteGuardProps> = ({ children }) => {
	const token = localStorage.getItem('token');

	if (!token) {
		return <Navigate to="/login" replace />;
	}
	return <>{children}</>;
};
